import { StorageState } from '../../../../reducers';
import { createDataFetchSliceSelectors } from '../../../../utils/dataFetch';


export const adminAccountStatisticChargesSliceSelector = (state: StorageState) => state.adminAccount.statistic.charges;

export const adminAccountStatisticChargesSelectors = createDataFetchSliceSelectors(
    adminAccountStatisticChargesSliceSelector
);
